import { Controller, useFormContext } from "react-hook-form";

import { TextArea } from "ui/text-area";

import { Button } from "ui/button";
import { DialogActions, DialogBackButton } from "ui/dialog";
import { useCampaignWithWriterContext } from "components/modals/create-campaign-with-writer-modal/context/campaign-with-writer-context";
import { useSubmitCampaignWithWriter } from "components/modals/create-campaign-with-writer-modal/hooks/use-submit-campaign-with-writer";
import type { CreateCampaignWithWriterFormData } from "components/modals/create-campaign-with-writer-modal/create-campaign-with-writer-modal.types";

export const EmailInstructionsStep = () => {
  const { control } = useFormContext<CreateCampaignWithWriterFormData>();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-4 text-gray-900">
        <p>
          Apollo generates the emails based on client program strategy. To tailor tone, content, or
          structure, you can edit the program strategy for this client.
        </p>
        <p>Add any additional instructions if needed for this specific emails.</p>
      </div>

      <div className="flex flex-col gap-4">
        <Controller
          name="emailAdditionalInstructions"
          control={control}
          render={({ field: { onChange, value, ...field } }) => (
            <TextArea
              label={<span className="font-bold">Email additional instructions</span>}
              value={value || ""}
              onChange={(event) => onChange(event.target.value)}
              rows={5}
              {...field}
            />
          )}
        />
      </div>
    </div>
  );
};

export const EmailInstructionsStepActions = () => {
  const { back: handleBack } = useCampaignWithWriterContext();
  const { handleCreateCampaign, isContinueDisabled } = useSubmitCampaignWithWriter();

  return (
    <DialogActions
      type="steps"
      back={
          <DialogBackButton onClick={handleBack}>Back to name</DialogBackButton>
        }
      primary={
          <Button size="large" disabled={isContinueDisabled} onClick={handleCreateCampaign}>
            Create campaign
          </Button>
        }
    />
  );
};
